module.exports = {"loading":"Nahrávám data","text":"Tato operace může trvat několik sekund, mějte prosím strpení..."}